import { IconImage } from "@nova/protobuf"
import {
    addEntitySocket,
    deleteEntitySocket,
    updateEntitySocket,
} from "features/entity-caching/project/slice"
import { generateGenericCases } from "features/pubsub/generateCases"
import { Builder } from "features/pubsub/sockets"
import { pick } from "nodash"
import {
    CreateIconImageArgs,
    getDefaultIconImageCreateArgs,
    UpdateIconImageArgs,
} from "@nova/serializer/src/client/validators/images/icon"

const {
    create: createIconImage,
    update: updateIconImage,
    delete: deleteIconImage,
    createAction,
    updateAction,
    deleteAction,
} = generateGenericCases<
    IconImage, // entity type
    CreateIconImageArgs, // create args to send to server
    [
        "index",
        "fileName",
        "size",
        "longitude",
        "latitude",
        "altitude",
        "takenAt",
        "focalLength",
        "make",
        "imageWidth",
        "imageHeight",
        "hasThumbnail",
    ], // create args required by action
    UpdateIconImageArgs, // update args
    { flightId: string } // context // TODO: Change to entityId
>("IconImage")

export const addIconImagesToBuilder = (builder: Builder) =>
    builder
        .addCase(createAction, (store, { payload: { data, context } }, socket) => {
            if ("name" in data) delete data.name
            const optimisticData = pick(
                {
                    ...data,
                    ...getDefaultIconImageCreateArgs(),
                } as Record<keyof IconImage, unknown>,
                Object.keys(IconImage.create()) as (keyof IconImage)[]
            ) as IconImage

            createIconImage(socket, { ...optimisticData }, context)
            store.dispatch(
                addEntitySocket({
                    data: optimisticData,
                    path: ["icons", { id: context.flightId }, "images"],
                })
            )
        })
        .addCase(updateAction, (store, { payload: { id, updates, context } }, socket) => {
            updateIconImage(socket, id, updates, context)
            store.dispatch(
                updateEntitySocket({
                    updates,
                    path: ["icons", { id: context.flightId }, "images", { id }],
                })
            )
        })
        .addCase(deleteAction, (store, { payload: { id, context } }, socket) => {
            deleteIconImage(socket, id, context)
            store.dispatch(
                deleteEntitySocket({
                    path: ["icons", { id: context.flightId }, "images", { id }],
                })
            )
        })

export {
    createAction as createIconImage,
    updateAction as updateIconImage,
    deleteAction as deleteIconImage,
}
